<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -extra-width"
       [ngClass]="{'-is-open' : tixxSelectOverviewService.listOfModals.editProcessConfigurationModalOpened,
                  '-is-closed': !tixxSelectOverviewService.listOfModals.editProcessConfigurationModalOpened}">

  <div class="esf-main-sidebar__content">
    <h3 i18n='Customer data edit modal title@@tixxSelect.modalTitle.editProcessConfiguration'>Edit Process Configuration</h3>
    <form [formGroup]="updateProcessConfigurationForm" (ngSubmit)="updateFormSubmit(updateProcessConfigurationForm)" id="updateProcessConfigurationForm">

      <div app-form-field-select
           [control]="updateProcessConfigurationForm.get('secondaryTicketRequestAvailable')"
           [label]="flTranslations.i18nSecondaryRequest"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div app-form-field-select
           [control]="updateProcessConfigurationForm.get('possiblePriceDeviation')"
           [label]="flTranslations.i18nPossiblePriceDeviation"
           [array]="possiblePriceDeviationDropdown">
      </div>

      <div app-form-field-select
           [control]="updateProcessConfigurationForm.get('optionalNonContiguousSeating')"
           [label]="flTranslations.i18nOptionalNonContiguousSeating"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div app-form-field-select
           [control]="updateProcessConfigurationForm.get('submissionsWithdrawableByOwner')"
           [label]="flTranslations.i18nDeletableSelfService"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <!-- <div app-form-field-select
           [control]="updateProcessConfigurationForm.get('ticketPersonalizationEnabled')"
           [label]="flTranslations.i18nTicketPersonalization"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div> -->

      <div app-form-field-select
           [control]="updateProcessConfigurationForm.get('showPrices')"
           [label]="flTranslations.i18nDisplayPrices"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div app-form-field-select
           [control]="updateProcessConfigurationForm.get('orderRequestRequired')"
           [label]="flTranslations.i18nDeliveryPaymentMethod"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div class="esf-form-group">

        <div app-form-field-select
             [control]="updateProcessConfigurationForm.get('delivery').get('deliveryMethod')"
             [label]="flTranslations.i18nShippingMethod"
             [useNgValue]="true"
             [array]="deliveryDropdown">
        </div>

        <div app-form-field-number
             [control]="updateProcessConfigurationForm.get('delivery').get('deliveryFee')"
             [placeholder]="flTranslations.i18nShippingFee"
             [label]="flTranslations.i18nShippingFee">
        </div>
      </div>

      <div class="esf-form-group">
        <div app-form-field-datepicker
             [enableTime]="true"
             class="esf-form-item--1-2"
             [control]="updateProcessConfigurationForm.get('submissionCollectionTiming').get('start')"
             [placeholder]="flTranslations.i18nStart"
             [label]="flTranslations.i18nStart">
        </div>

        <div app-form-field-datepicker
             [enableTime]="true"
             class="esf-form-item--1-2"
             [control]="updateProcessConfigurationForm.get('submissionCollectionTiming').get('deadline')"
             [placeholder]="flTranslations.i18nEnd"
             [label]="flTranslations.i18nEnd">
        </div>
      </div>

    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -extra-width"
     [ngClass]="{'-is-open': tixxSelectOverviewService.listOfModals.editProcessConfigurationModalOpened}">
  <app-submit-row-buttons [form]="'updateProcessConfigurationForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          [isFieldValid]="selectedLottery.isDraftMode || selectedLottery.isEditMode"
                          (cancelButton)="tixxSelectOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space -has-transition"
     (click)="tixxSelectOverviewService.toggleAllModal(false)"
     [ngClass]="{'-is-open': tixxSelectOverviewService.listOfModals.editProcessConfigurationModalOpened}">
  <span class="esf-hamburger__icon"></span>
</div>
